import React, { useRef, useState } from 'react'
import { config } from './config.ts'
import { message, Switch } from 'antd'
import { SActionBtn, SLowcodeList, SMessage, STableActions } from 'shj-components'
import AddOrEditDom from './components/AddOrEdit'
import {
  delEvaluationType,
  getTreeEvaluationType,
  updateStateEvaluationType
} from '@/services/evaluateConfig.ts'
import { isArray } from 'lodash-es'

const EvalutionQuestionClass: React.FC = () => {
  const listRef = useRef<any>()
  const [isVisible, setIsVisible] = useState(false)
  const [currentRecord, setCurrentRecord] = useState<any>([])

  const fetchList = ({ query }: any) => {
    return new Promise((resolve, reject) => {
      getTreeEvaluationType({
        ...query,
      })
        .then((res: any) => {
          const records = isArray(res) ? res : []
          console.log(111, res)
          resolve({ records })
        })
        .catch(() => {
          reject({ success: false })
        })
    })
  }

  const onAddOrEdit = () => {
    setIsVisible(true)
    setCurrentRecord({ type: 'add'})
  }
  // 删除
  const deleteFn = (id: string) => {
    SMessage.delete({
      onOk() {
        return delEvaluationType(id).then((res: any) => {
            message.success(res?.message || "删除成功");
            listRef?.current?.reload();
        });
      },
    })
  }

  const onChangeStatus = (record: any,state: boolean ) => {
    onEnableChange(record, state)
  }
  const onEnableChange = (record, state) => {
    SMessage.confirm({
      title: `修改状态`,
      content: `是否确认${state ? '启用' : '禁用'}所选数据`,
      onOk: () => {
        return updateStateEvaluationType({
          id:record?.id||"",
          state
        }).then(
            (res: any) => {
                message.success(res.message || '操作成功')
                listRef.current?.reload()
            }
        )
      },
    })
  }

  const extension = {
    request: {
      fetchList,
    },
    events: {
      onAddOrEdit,
    },
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return (
          <Switch
            checked={v}
            checkedChildren="启用"
            unCheckedChildren="禁用"
            disabled={record?.object?.sysConfig}
            onClick={checked => onChangeStatus(record,checked)}
          />
        )
      },
      operationFn(text: any, record: any) {
        const lvl = record?.object?.lvl || 0;
        return (
          <STableActions>
            <SActionBtn
              auth={''}
              onClick={() => {
                setIsVisible(true)
                setCurrentRecord({
                  ...record,
                  type:'edit'
                })
              }}
            >
              编辑
            </SActionBtn>
            {lvl !== 4 ? <SActionBtn
              onClick={() => {
                setIsVisible(true)
                setCurrentRecord({
                  ...record,
                  type:'addNext'
                })
              }}
            >添加下级</SActionBtn> : null}
            {
              !record?.object?.sysConfig?<SActionBtn danger onClick={() => deleteFn(record?.id)}>
                删除
              </SActionBtn>:null
            }
          </STableActions>
        )
      },
    },
  }

  return (
    <>
      <SLowcodeList config={{ ...config }} searchMode={'group'} ref={listRef} {...extension} />
      {isVisible ? (
        <AddOrEditDom
          open={isVisible}
          record={currentRecord}
          onClose={() => {
            setIsVisible(false)
            setCurrentRecord({})
          }}
          reload={listRef.current?.reload}
        />
      ) : null}
    </>
  )
}

export default EvalutionQuestionClass
